class CountdownPoster extends HTMLElement {
  #canvas;
  #observer;
  #frame;

  connectedCallback() {
    this.#canvas = this.querySelector('.product-single__countdown__canvas');
    if (!this.#canvas) return;
    this.#observer = new ResizeObserver(() => this.#schedule());
    this.#observer.observe(this);
    this.#observer.observe(this.#canvas);
    this.#schedule();
    document.fonts?.ready.then(() => {
      if (this.isConnected) this.#schedule();
    });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
  }

  #schedule() {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#scale());
  }

  #scale() {
    const width = this.clientWidth;
    const canvasWidth = this.#canvas.offsetWidth;
    const canvasHeight = parseFloat(getComputedStyle(this.#canvas).height);
    if (!width || !canvasWidth || !canvasHeight) return;
    const scale = width / canvasWidth;
    const height = `${canvasHeight * scale}px`;
    const factor = String(scale);
    if (this.style.getPropertyValue('--poster-scale') !== factor) {
      this.style.setProperty('--poster-scale', factor);
    }
    if (this.style.height !== height) this.style.height = height;
    this.setAttribute('data-scaled', '');
  }
}

if (!customElements.get('countdown-poster')) {
  customElements.define('countdown-poster', CountdownPoster);
}
